import React, { useEffect, useState } from "react";
import Layout from "../../../../Components/Layout";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import ProSelectField from "../../../../Components/Inputs/SelectField";
import ProTextInput from "../../../../Components/Inputs/TextField";
import ProCheckbox from "../../../../Components/Inputs/CheckboxField";
import { STAUTES } from "../../../../../utils/constant";
import { changeMode, changeModeForField, fieldTruePermission, prepareDefaultValues, prepareInitialConfig } from "../../../../../utils/formHelper";
import ProFormsLayout from "../../../../Components/ProForms/ProFormsLayout";
import {
  ADMIN_RAP_INFO,
  GET_ADMIN_INDUSTRY_TYPES,
  GET_ADMIN_JOB_CATEGORIES,
  GET_CLIENT_JOB_TITLES,
  GET_SPONSOR_INFORMATION,
  GET_SAA_STATES,
  GET_OA_STATES
} from "../../../../../utils/services/apiPath";
import { getApi, postApi } from "../../../../../utils/services";
import { errorToast, successToast } from "../../../../../utils/toastHelper";
import { apprenticeRapPermissionSelector } from "../../../../store/features/permissions/permissionsSlice";
import usePermission from "../../../../../utils/customHooks/usePermission";
import { rapInfoFormConfig } from "../RapInfoProfile";
import { v4 as uuidv4 } from "uuid";

const ApprenticeshipApproachDropDown = [{ label: "Time-based" }, { label: "Competency-based" }, { label: "Hybrid" }];

export default function RapInfoProfile() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(STAUTES.IDLE);
  const [jobTitleDropDown, setJobTitleDropDown] = useState([]);
  const [industryDropDown, setIndustryDropDown] = useState([]);
  const [jobCategoryDropDown, setJobCategoryDropDown] = useState([]);
  const [ssaStateDropDown, setSsaStateDropDown] = useState([]);
  const [dolStateDropDown, setDolStateDropDown] = useState([]);
  const [apprenticeshipApproachDropDown, setApprenticeshipApproachDropDown] = useState([]);
  const [sponsorDropDown, setSponsorDropDown] = useState([]);
  const [otjHoursArray, setOtjHoursArray] = useState([]);
  const [formConfig, setFormConfig] = useState(prepareInitialConfig(rapInfoFormConfig, "edit"));
  const { handleSubmit, control, watch, setValue, trigger } = useForm({ defaultValues: prepareDefaultValues(rapInfoFormConfig) });
  const isEditModeOn = true;
  const [isSaving, setIsSaving] = useState(false);
  const { "Rap Info List": rapInfoListPermission } = usePermission(apprenticeRapPermissionSelector, "Rap Info List");

  const programLength = watch("programLength");
  const isDOL = watch("isDOL");
  const isSSA = watch("isSSA");

  const backAction = () => navigate("/apprentice-180/rap");
  const onEdit = () => setFormConfig(changeMode("edit"));
  const onCancel = () => {
    backAction();
  };

  const handleReadValueClick = name => setFormConfig(changeModeForField(name, "edit"));

  const onSubmit = async data => {
    if (isSaving) return;
    setIsSaving(true);
    setStatus(STAUTES.LOADING);
    const otj = otjHoursArray?.map(ot => parseInt(ot.OTJHoursYear));
    const eLearn = otjHoursArray?.map(ot => parseInt(ot.eLearningHoursYear));
    const payload = {
      clientJobTitleGuid: data?.externalJobTitle,
      approvedJobTitle: data?.approvedJobTitle,
      industryTypeId: data?.industry,
      categoryId: data?.category,
      rapidCode: data?.rapidCode,
      summary: data?.summary,
      description: data?.description,
      programLengthYears: data?.programLength,
      isdol: data?.isDOL,
      isssa: data?.isSSA,
      ssaStateId: data?.SSAState,
      sponsorId: data?.sponsor,
      apprenticeshipApproach: data?.apprenticeshipApproach,
      isRtiTrackedByThirdParty: data?.isRTI,
      isOjtTrackedByThirdParty: data?.isOTJ,
      rapProgram: {
        otjHoursYear: otj,
        eLearningHoursYear: eLearn,
        rapInfoId: null
      }
    };
    const { error } = await postApi(ADMIN_RAP_INFO, payload);
    setIsSaving(false);
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    successToast(`RAP Info Added Successfully`);
    backAction();
  };

  const getAllJobTitles = async () => {
    const { data, error } = await getApi(GET_CLIENT_JOB_TITLES);
    if (error) return;
    setJobTitleDropDown(data);
  };

  const getAllIndustry = async () => {
    setStatus(STAUTES.LOADING);
    const { data } = await getApi(GET_ADMIN_INDUSTRY_TYPES);
    setIndustryDropDown(data);
    setStatus(STAUTES.IDLE);
  };

  const getAllJobCategory = async () => {
    setStatus(STAUTES.LOADING);
    const { data } = await getApi(GET_ADMIN_JOB_CATEGORIES);
    setJobCategoryDropDown(data);
    setStatus(STAUTES.IDLE);
  };

  const getAllSSAStates = async () => {
    setStatus(STAUTES.LOADING);
    const { data } = await getApi(GET_SAA_STATES);
    setSsaStateDropDown(data?.filter(item => item.label !== "All States")?.map(item => ({ label: item.label, value: item.value })));
    setStatus(STAUTES.IDLE);
  };

  const getAllDOLStates = async () => {
    setStatus(STAUTES.LOADING);
    const { data } = await getApi(GET_OA_STATES);
    setDolStateDropDown(data?.filter(item => item.label !== "All States")?.map(item => ({ label: item.label, value: item.value })));
    setStatus(STAUTES.IDLE);
  };

  const getAllApprenticeshipApproachDropDown = async () => {
    setApprenticeshipApproachDropDown(ApprenticeshipApproachDropDown.map(item => ({ label: item.label, value: item.label })));
  };

  const getAllSponsorDropDown = async () => {
    const { data } = await getApi(GET_SPONSOR_INFORMATION);
    setSponsorDropDown(data);
  };

  const handleInputChange = (e, index, fieldIndex) => {
    const { value } = e.target;
    const updatedArray = [...otjHoursArray];

    if (index >= 0 && index < updatedArray.length) {
      if (fieldIndex === 1 || fieldIndex === 2) {
        updatedArray[index][fieldIndex === 1 ? "OTJHoursYear" : "eLearningHoursYear"] = value;
        setOtjHoursArray(updatedArray);
      } else {
        console.error(`Invalid fieldIndex ${fieldIndex}`);
      }
    } else {
      console.error(`Index ${index} is out of bounds for otjHoursArray`);
    }
  };

  useEffect(() => {
    if (programLength) {
      setOtjHoursArray(
        Array.from({ length: programLength }, (_, index) => {
          const { OTJHoursYear = "", eLearningHoursYear = "" } = otjHoursArray[index] || {};
          return { OTJHoursYear, eLearningHoursYear, id: uuidv4() };
        })
      );
    }
  }, [programLength]);

  useEffect(() => {
    getAllJobTitles();
    getAllIndustry();
    getAllJobCategory();
    getAllSSAStates();
    getAllDOLStates();
    getAllApprenticeshipApproachDropDown();
    getAllSponsorDropDown();
  }, []);

useEffect(() => {
  if (typeof isDOL === "boolean") {
    setValue("isSSA", !isDOL);
    setValue("SSAState", null);              
  }
}, [isDOL, setValue]);             

useEffect(() => {
  if (typeof isSSA === "boolean") {
    setValue("isDOL", !isSSA);
    setValue("SSAState", null);               
  }
}, [isSSA, setValue]);             

  const defaultFormProps = { control, formValues: {}, isAddMode: true, handleReadValueClick };
  return (
    <Layout canView={rapInfoListPermission.canAdd}>
      <ProFormsLayout
        status={status}
        backAction={backAction}
        title={`Add Rap Info`}
        backLabel="Go Back to Rap Info"
        beingEdited={isEditModeOn}
        onEdit={onEdit}
        onCancel={onCancel}
        onSave={handleSubmit(onSubmit)}
        isSaving={isSaving}
      >
        <Grid container spacing={2}>
          <ProSelectField {...defaultFormProps} {...formConfig.externalJobTitle} options={jobTitleDropDown} permission={fieldTruePermission} />
          <ProTextInput {...defaultFormProps} {...formConfig.approvedJobTitle} permission={fieldTruePermission} />
          <ProSelectField {...defaultFormProps} {...formConfig.industry} permission={fieldTruePermission} options={industryDropDown} />
          <ProSelectField {...defaultFormProps} {...formConfig.category} permission={fieldTruePermission} options={jobCategoryDropDown} />
          <ProSelectField
            {...defaultFormProps}
            {...formConfig.apprenticeshipApproach}
            permission={fieldTruePermission}
            options={apprenticeshipApproachDropDown}
          />
          <ProSelectField {...defaultFormProps} {...formConfig.sponsor} permission={fieldTruePermission} options={sponsorDropDown} />
          <ProTextInput {...defaultFormProps} {...formConfig.summary} permission={fieldTruePermission} />
          <ProTextInput {...defaultFormProps} {...formConfig.description} permission={fieldTruePermission} />
          <ProTextInput {...defaultFormProps} {...formConfig.rapidCode} permission={fieldTruePermission} />
          <ProCheckbox {...defaultFormProps} {...formConfig.isDOL} permission={fieldTruePermission} />
          <ProCheckbox {...defaultFormProps} {...formConfig.isSSA} permission={fieldTruePermission} />
          {(isDOL || isSSA) && (
            <ProSelectField
              {...defaultFormProps}
              {...formConfig.SSAState}
              label={`${isDOL ? "DOL" : "SAA"} State`}
              permission={fieldTruePermission}
              options={isDOL ? dolStateDropDown : ssaStateDropDown}
            />
          )}
          <ProCheckbox {...defaultFormProps} {...formConfig.isOTJ} permission={fieldTruePermission} />
          <ProCheckbox {...defaultFormProps} {...formConfig.isRTI} permission={fieldTruePermission} />
          <ProTextInput {...defaultFormProps} {...formConfig.programLength} permission={fieldTruePermission} type="number" />
          {!!programLength &&
            otjHoursArray.map((_, index) => (
              <div key={_.id} style={{ display: "flex", width: "100%", marginBottom: "10px" }}>
                <div style={{ width: "33.3%", padding: "16px 0 0 16px" }}>
                  <ProTextInput
                    size={12}
                    fieldProps={{ value: _.OTJHoursYear, onChange: e => handleInputChange(e, index, 1) }}
                    control={control}
                    formValues={{ [`OTJHoursYear${index + 1}`]: _.OTJHoursYear }}
                    mode={formConfig.programLength.mode}
                    name={`OTJHoursYear${index + 1}`}
                    label={`OTJ Hours Year ${index + 1}`}
                    rules={{ required: `OTJ Hours Year ${index + 1} is required!` }}
                    permission={fieldTruePermission}
                  />
                </div>
                <div style={{ width: "33.3%", padding: "16px 0 0 16px" }}>
                  <ProTextInput
                    size={12}
                    fieldProps={{ value: _.eLearningHoursYear, onChange: e => handleInputChange(e, index, 2) }}
                    control={control}
                    formValues={{ [`eLearningHoursYear${index + 1}`]: _.eLearningHoursYear }}
                    mode={formConfig.programLength.mode}
                    name={`eLearningHoursYear${index + 1}`}
                    label={`Learning Hours Year ${index + 1}`}
                    rules={{ required: `Learning Hours Year ${index + 1} is required!` }}
                    permission={fieldTruePermission}
                    isSaving={isSaving}
                  />
                </div>
              </div>
            ))}
        </Grid>
      </ProFormsLayout>
    </Layout>
  );
}
